





























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class ModalExportarCRM extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) id_orden_compra: any;
  //@Prop({ default: null }) po_sel: any;

  archivoB64: any = '';
  fileName: any = '';

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  //showReporteGenerado: boolean = false;
  //texto_reporte: string = 'TEXTO CUERPO MODAL';

  handleInfoGeneral() {
    this.showInfo = true;
  }
  mounted() {}

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeModal() {
    this.$emit('modalOrdenCompraEmit', false);
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  descargarPlantilla() {
    this.loadingService.showLoading(undefined, 'get_tipoeqname_from_oc');
    return fetchOrdenesCompra(
      {
        id_orden_compra: this.id_orden_compra,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/get_tipoeqname_from_oc'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_tipoeqname_from_oc');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          let headers = {
            //header: ['Equipo y Periferico','Suma de comprobación de fila','Fecha de modificación','Nombre','Identificador','Razón para el estado','Propiedad Equipo','Propietario','Producto','Serie','Plataforma','Cambio de Batería','Simcard','Fecha Cambio de Batería','Observaciones'],
          };
          const ws = utils.json_to_sheet(data.data.LISTA, headers);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, 'Plantilla');
          writeFileXLSX(wb, 'ExportarCRM.xlsx');
          this.$snotify.success('Plantilla Excel descargada con éxito');
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end descargar plantilla
} //end class
